<template>
    <div class="sets-concurrency-tip">
        <modal class="sets-concurrency-modal" :visible.sync="show" :backdrop="true">
            <div slot="header" class="modal-header">
                <a class="btn btn-default" target="_blank" href="/help/open/index#price">查看权限</a>
                <button type="button"
                        class="close" data-dismiss="modal"
                        aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title">并发限制</h4>
            </div>
            <div class="mt20">
                <h5>温馨提示</h5>
                <p class="mt10">
                    为了更好地为用户提供优质服务，百一对免费用户的在线考试人数限制为 <span class="mark-text">100</span>
                    人，超出则会在答题端提示“当前进入考试人数过多，请稍后再试”。VIP
                    用户和企业版用户不受此限制。如果用户有大规模在线考试需求，请及时升级为 VIP 或开通企业版，避免影响考生答题体验。
                </p>
                <p class="alert alert-warning m0 mt10">
                    注：在线考试人数指已进入考试、处于答题中的人数，未进入或已交卷则不计入，VIP群组中发生的考试也不计入。
                </p>
            </div>
            <div class="modal-footer" slot="footer">
                <button type="button"
                        class="btn btn-warning"
                        @click='okClicked'>
                    我知道了
                </button>
            </div>
        </modal>
    </div>
</template>

<style>
    .sets-concurrency-modal .modal-header {
        background-image: url("/assets/img/banner.png");
        background-repeat: no-repeat;
        background-position: center bottom;
        background-size: contain;
        height: 120px;
        background-color: #17a2dd;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
    }

    .sets-concurrency-modal .modal-header h4 {
        display: none;
    }

    .sets-concurrency-modal .modal-header a {
        margin-left: 370px;
        margin-top: 42px;
        border: none;
        color: #ff401d;
    }

    .sets-concurrency-modal .modal-body .mark-text {
        color: #ff401d;
        font-size: 1.4em;
    }
</style>
<script lang="babel">
    import modal from 'bootsets/components/modal'
    import store from 'store'
    import {user, env, company} from 'bootsets/runtime'
    import {EmployerType} from 'core/constant'
    export default{
        components: {
            modal
        },
        data(){
            return {
                show: false
            }
        },
        methods: {
            okClicked(){
                this.show = false
            },
            isShow(){
                let hasShow = store.get('sets_concurrency_tip_' + user.employerId)
                return user.isExaminer && !env.isCompanyDomain && user.login && !hasShow
            }
        },
        watch: {
            show(val){
                if (val) {
                    this.show = true
                } else {
                    $(this.$els.modal).modal('hide');
                    store.set('sets_concurrency_tip_' + user.employerId, true)
                }
            }
        },
        ready() {
            let self = this
            if (this.isShow()) {
                //self.show = true
            }
        }
    }
</script>



// WEBPACK FOOTER //
// concurrency-tip.vue?09018d1e